export default {
    PENDING_PAYMENT: '待支付',
    COMPLETED: '已完成',
    EXPIRED: '已过期',
    CANCELLATION: '已作废',
    IN_PAYMENT: '支付中',
    UNDER_REVIEW: '审批中',
    REJECTED: '已拒绝',
    INITIALIZED: '初始化状态',
}
